import { loadLoyaltyIsBenefitEventActive } from ".";
import { EARLY_ACCESS_SALE } from "../constants";

const loadLoyaltyIsEarlyAccessSaleEventActive = () => async dispatch => {
  dispatch(loadLoyaltyIsBenefitEventActive(EARLY_ACCESS_SALE));
};

export default loadLoyaltyIsEarlyAccessSaleEventActive;
